import { useEffect } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { ArrowLeft } from "lucide-react";
import { DOCS, getDoc } from "@/data/legal";

export default function Legal() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const doc = getDoc(slug);

  useEffect(() => { window.scrollTo(0, 0); }, [slug]);

  return (
    <div className="min-h-screen bg-background text-foreground">
      <div className="max-w-[1100px] mx-auto px-5 sm:px-8 py-10">
        <button onClick={() => navigate(-1)} data-testid="legal-back"
          className="inline-flex items-center gap-2 font-mono-data text-[11px] uppercase tracking-wider text-muted-foreground hover:text-foreground transition-colors mb-8">
          <ArrowLeft className="w-3.5 h-3.5" /> Back
        </button>

        <div className="grid lg:grid-cols-[220px_1fr] gap-10">
          <aside className="lg:sticky lg:top-8 self-start">
            <div className="font-mono-data text-[10px] uppercase tracking-[0.3em] text-accent mb-4">Legal</div>
            <nav className="flex flex-col gap-1" data-testid="legal-nav">
              {DOCS.map((d) => (
                <Link key={d.slug} to={`/legal/${d.slug}`} data-testid={`legal-link-${d.slug}`}
                  className={`rounded-lg px-3 py-2 text-sm transition-colors ${d.slug === doc.slug ? "bg-surface text-foreground border border-border" : "text-muted-foreground hover:text-foreground"}`}>
                  {d.title}
                </Link>
              ))}
            </nav>
          </aside>

          <article className="legal-prose max-w-none" data-testid={`legal-doc-${doc.slug}`}>
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{doc.body}</ReactMarkdown>
          </article>
        </div>
      </div>
    </div>
  );
}
